import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RegistrationService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'app-customer-account-creation',
  templateUrl: './customer-account-creation.component.html',
  styleUrls: ['./customer-account-creation.component.scss']
})
export class CustomerAccountCreationComponent implements OnInit {

  public error: boolean = false;
  public errMsg: string = '';
  public success: boolean = false;
  public successMsg: string = '';
  public companyDetails: any = [];
  public compPass: string = null;
  public inProgress: boolean = false
  private emailPattern: string = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,9}$"
  private passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!#%*?^_&]{12,20}$/;

  RegistrationForm = this.fb.group({
    companyName: [null, Validators.required],
    firstName: [null, Validators.required],
    lastName: [null, Validators.required],
    phone: [null, Validators.required],
    email: [null, Validators.required],
    department: [null, Validators.required],
    orgType: [null, Validators.required],
    title: [null, Validators.required],
    username: [null, Validators.required],
    password: [null, Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    public regService: RegistrationService,
    private router: Router
  ) { }

  ngOnInit() {
    this.companyDetails = JSON.parse(sessionStorage.getItem("companyDetails"));
    this.RegistrationForm.controls.companyName.disable();
    this.compPass = this.companyDetails['companypass'];

    if (this.compPass === '' || this.compPass === 'null') {
      window.scrollTo(0, 0)
      this.error = true;
      this.errMsg = "Unable to find Organisation details. Please enter access code again";
    } else {
      this.RegistrationForm.patchValue({ companyName: this.companyDetails['companyname'] })
    }
  }

  onRegistrationFormSubmit() {
    this.compPass = this.compPass ? this.compPass : this.companyDetails['companypass']
    this.error = false;
    this.success = false;
    let password: string = this.RegistrationForm.controls.password.value;
    let email: string = this.RegistrationForm.controls.email.value.toLowerCase();
    let emailDomain = email ? email.substring(email.indexOf('@') + 1, email.length) : '';
    this.inProgress = true;

    setTimeout(() => {
      this.inProgress = false;
    }, 60000);

    if (this.RegistrationForm.invalid || this.RegistrationForm.value.orgType === 'null') {
      window.scrollTo(0, 0)
      this.error = true;
      this.inProgress = false;
      this.errMsg = "Please fill in all the required fields";
      return;
    }

    if (email && !email.match(this.emailPattern)) {
      window.scrollTo(0, 0)
      this.error = true;
      this.inProgress = false;
      this.errMsg = 'The information you submitted for your email has an issue. It may be formatted incorrectly, blank or in use. Please try again. If this continues please contact Customer Service at Info@ReimbursementCodes.com.';
      return
    }

    if (password && !password.match(this.passwordPattern)) {
      window.scrollTo(0, 0)
      this.error = true;
      this.inProgress = false;
      this.errMsg = "Password format is incorrect";
      return
    }

    if (this.RegistrationForm.controls.phone.value.length !== 10) {
      window.scrollTo(0, 0)
      this.error = true;
      this.inProgress = false;
      this.errMsg = "Phone number format is incorrect.";
      return;
    }

    let emailJsonData = {
      'email': email,
      'site': "0",
      "category": null
    }

    this.regService.validateEmail(emailJsonData).subscribe(response => {
      let status = response['status'];

      if (status === 0 || status === '0') {
        this.error = false;
        let userJsonData = {
          'username': this.RegistrationForm.controls.username.value,
          'site': "0",
          "category": null
        }

        this.regService.validateUsername(userJsonData).subscribe(resp => {
          let status = resp['status'];
          if (status === 0 || status === '0') {
            this.error = false;

            let jsonData = {
              'contact_first': this.RegistrationForm.controls.firstName.value,
              'contact_last': this.RegistrationForm.controls.lastName.value,
              'phone': this.RegistrationForm.controls.phone.value,
              'email': this.RegistrationForm.controls.email.value,
              'department': this.RegistrationForm.controls.department.value,
              'title': this.RegistrationForm.controls.title.value,
              'specialty': this.RegistrationForm.controls.orgType.value,
              'username': this.RegistrationForm.controls.username.value,
              'password': this.RegistrationForm.controls.password.value,
              'orgid': this.companyDetails.org_id.toString(),
              'companypass': this.compPass,
              'address_1': "",
              'address_2': "",
              'fax': "",
              'city': "",
              'state': "",
              'zip': "",
              'hear_about_us': "",
              'npi': "",
              'other': "VRFY",
            }

            this.regService.addAccount(jsonData).subscribe(res1 => {
              if (res1[0]['message'] === 'Add account successful') {
                this.success = true;
                this.successMsg = "Account added successfully"
                let verificationData = {
                  'first_name': this.RegistrationForm.controls.firstName.value,
                  'last_name': this.RegistrationForm.controls.lastName.value,
                  'email': email,
                  'user_name': this.RegistrationForm.controls.username.value,
                  'password': this.RegistrationForm.controls.password.value,
                  'orgId': '1',
                  'category': "CA",
                  'verification_aa_id': res1[0]['verfication_aa_id'],
                  'account_id': res1[0]['account_id'],
                  'site': '0'
                }

                this.regService.varificationEmail(verificationData).subscribe(vryres => {
                  let vryStatus = vryres['status']
                  this.inProgress = false;
                  if (vryStatus === 0 || vryStatus === '0') {
                    this.success = true;
                    this.successMsg = 'An email has been sent to you email id with the username and password.'
                  } else if (vryStatus === '1' || vryStatus === 1) {
                    this.error = true;
                    this.errMsg = 'Email not sent';
                  } else {
                    this.error = true;
                    this.errMsg = 'Error in sending email';
                  }
                }, () => {
                  this.error = true;
                  this.errMsg = 'Error in sending email';
                });

                window.scrollTo(0, 0);
                alert('Your account has been registered successfully.');
                this.router.navigate(['/about']);
              }
            }, () => {
              this.error = true;
              this.inProgress = false;
              this.errMsg = 'Unable to register account. Please enter access code and try again';
            });
          } else if (status === '1' || status === 1) {
            window.scrollTo(0, 0)
            this.error = true;
            this.inProgress = false;
            this.errMsg = 'The information you submitted for your username has an issue. It may be formatted incorrectly, blank or in use. Please try again. If this continues please contact Customer Service at Info@ReimbursementCodes.com.';
          } else if (status === '2' || status === 2) {
            window.scrollTo(0, 0)
            this.error = true;
            this.inProgress = false;
            this.errMsg = 'The information you submitted for your username has an issue. It may be formatted incorrectly, blank or in use. Please try again. If this continues please contact Customer Service at Info@ReimbursementCodes.com.';
          } else {
            window.scrollTo(0, 0)
            this.error = true;
            this.inProgress = false;
            this.errMsg = 'The information you submitted for your username has an issue. It may be formatted incorrectly, blank or in use. Please try again. If this continues please contact Customer Service at Info@ReimbursementCodes.com.';
          }
        }, () => {
          window.scrollTo(0, 0)
          this.error = true;
          this.inProgress = false;
          this.errMsg = 'The information you submitted for your username has an issue. It may be formatted incorrectly, blank or in use. Please try again. If this continues please contact Customer Service at Info@ReimbursementCodes.com.';
        });
      } else if (status === '1' || status === 1) {
        window.scrollTo(0, 0)
        this.error = true;
        this.inProgress = false;
        this.errMsg = 'Email domain is already registered';
      } else if (status === '2' || status === 2) {
        window.scrollTo(0, 0)
        this.error = true;
        this.inProgress = false;
        this.errMsg = 'The information you submitted for your email has an issue. It may be formatted incorrectly, blank or in use. Please try again. If this continues please contact Customer Service at Info@ReimbursementCodes.com.';
      } else if (status === '3' || status === 3) {
        window.scrollTo(0, 0)
        this.error = true;
        this.inProgress = false;
        this.errMsg = 'The information you submitted for your email has an issue. It may be formatted incorrectly, blank or in use. Please try again. If this continues please contact Customer Service at Info@ReimbursementCodes.com.';
      } else if (status === '4' || status === 4) {
        window.scrollTo(0, 0)
        this.error = true;
        this.inProgress = false;
        this.errMsg = "Based on your email address, your organization has an account with ReimbursementCodes.com or has completed a Free Trial previously. If you have a company affiliated access code, please select the Current Customer Section of this form to continue. If you don't know your access code, please contact Client Relations at: Info@ReimbursementCodes.com"
      } else {
        window.scrollTo(0, 0)
        this.error = true;
        this.inProgress = false;
        this.errMsg = 'The information you submitted for your email has an issue. It may be formatted incorrectly, blank or in use. Please try again. If this continues please contact Customer Service at Info@ReimbursementCodes.com.';
      }
    }, () => {
      window.scrollTo(0, 0)
      this.error = true;
      this.inProgress = false;
      this.errMsg = 'The information you submitted for your email has an issue. It may be formatted incorrectly, blank or in use. Please try again. If this continues please contact Customer Service at Info@ReimbursementCodes.com.';
    });
  }
}